import { Stack } from '@stereograph/teia-system-design/components/Stack';
import { AnomalyCardVisualizeDocument } from './AnomalyCardVisualizeDocument';
import { AnomalyDocumentCardDelete } from './AnomalyDocumentCardDelete';
import { AnomalyDocumentCardDownload } from './AnomalyDocumentCardDownload';

export const AnomalyDocumentCardActions = () => {
  return (
    <Stack
      className="actions"
      sx={{
        position: 'absolute',
        right: 0,
        transitionProperty: 'all',
        transitionDuration: '100ms',
        opacity: 0,
        visibility: 'hidden',
      }}
      direction="row"
      spacing={1}
      justifyContent="flex-end"
      alignItems="center"
    >
      <AnomalyCardVisualizeDocument />
      <AnomalyDocumentCardDownload />
      <AnomalyDocumentCardDelete />
    </Stack>
  );
};
